import React from 'react';
import {
  ScrollView,
  StatusBar,
  StyleSheet,
  Text,
  View,
} from './components/base_components';
import HomeTop from './components/home_top';
import TabSelect from './components/tab_select';

import BuySellScreen from './buy_sell_screen';
import OrderScreen from './order_screen';

import CoinStore from './stores/coin_store';

import Analytics from './tools/analytics';
import util from './tools/util';

const styles = StyleSheet.create({
  homeScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#f1f1f1',
  },
  homeTop: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: '#333',
  },
  scroll: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
  },
  scrollInner: {
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  topSpacer: {
    height: '4rem',
  },
  bottomSpacer: {
    height: '7rem',
  },
  spinner: {
    marginTop: '2rem',
  },
  tabSelect: {
    marginTop: '1rem',
    width: '32rem',
    borderRadius: '0.5rem',
    height: '3.5rem',
  },
  tabButton: {
    flex: 1,
    alignSelf: 'stretch',
    borderRightWidth: StyleSheet.hairlineWidth,
    borderRightColor: '#555',
  },
  versionView: {
    position: 'absolute',
    bottom: '0.5rem',
    right: '1rem',
  },
  version: {
    color: '#999',
    fontSize: '1rem',
    fontWeight: 'bold',
  },
  spacer: {
    flex: 1,
  },
});

const TABS = [
  {
    value: 'buy',
    text: 'Buy',
  },
  {
    value: 'sell',
    text: 'Sell',
  },
  {
    value: 'order',
    text: 'Orders',
  },
];
type Props = {};
type State = {
  has_wallet: boolean;
  active_tab: 'buy' | 'sell';
  token: any;
  currency: any;
  quantity: string;
  price: string;
};
export default class HomeScreen extends React.PureComponent<Props, State> {
  constructor(props, context) {
    super(props, context);
    this.state = {
      active_tab: props.match.path.slice(1) || 'buy',
      quantity: _get('quantity') || '',
      price: _get('price') || '',
      token: _getCoin('token'),
      currency: _getCoin('currency'),
    };
  }
  _disarm = false;
  componentDidMount() {
    Analytics.showScreen('home');
  }
  _onTabSelect = (active_tab) => {
    const url = '/' + active_tab;
    this.props.history.replace(url);
    this.setState({ active_tab });
  };
  _onTokenChange = (token) => this.setState({ token });
  _onCurrencyChange = (currency) => this.setState({ currency });
  _onQuantityChange = (quantity) => this.setState({ quantity });
  _onPriceChange = (price) => this.setState({ price });
  _onSwapPress = () => {
    const { token, currency } = this.state;
    this.setState({ token: currency, currency: token });
  };

  render() {
    const { active_tab, token, currency, quantity, price } = this.state;
    let ver = util.getVersion();
    if (util.getEnvironment() === 'dev') {
      ver += '(dev)';
    }

    let content = null;
    if (active_tab === 'buy' || active_tab === 'sell') {
      content = (
        <BuySellScreen
          isBuy={active_tab === 'buy'}
          token={token}
          currency={currency}
          quantity={quantity}
          price={price}
          onTokenChange={this._onTokenChange}
          onCurrencyChange={this._onCurrencyChange}
          onQuantityChange={this._onQuantityChange}
          onPriceChange={this._onPriceChange}
          onSwapPress={this._onSwapPress}
        />
      );
    } else {
      content = <OrderScreen />;
    }

    return (
      <View style={styles.homeScreen}>
        <StatusBar barStyle='light-content' />
        <ScrollView
          style={styles.scroll}
          contentContainerStyle={styles.scrollInner}
        >
          <View style={styles.topSpacer} />
          <HomeTop />
          <TabSelect
            style={styles.tabSelect}
            buttonStyle={styles.tabButton}
            tabs={TABS}
            value={active_tab}
            onSelect={this._onTabSelect}
          />
          {content}
          <View style={styles.bottomSpacer} />
          <View style={styles.versionView}>
            <Text style={styles.version}>{ver}</Text>
          </View>
        </ScrollView>
      </View>
    );
  }
}

function _getCoin(name: string) {
  let ret = null;
  const chain_id = parseInt(_get('chain_id'));
  const addr = _get(name);
  const contract_addr =
    addr === 'native' ? '0x0000000000000000000000000000000000000000' : addr;
  if (chain_id > 0 && contract_addr !== undefined) {
    const coin = CoinStore.getCoinByAddress(chain_id, contract_addr);
    if (coin && coin.symbol) {
      ret = coin;
    }
  }
  return ret;
}
function _get(name: string) {
  return util.urlHashGet(name) || util.urlQueryGet(name);
}
